import { AxiosResponse } from "axios";
import CheckAutomatResponse from "../interface/CheckAutomat";

const AutomatCheckDTO = {
  convertResponseToAutomatCheckDTO: (
    response: AxiosResponse
  ): CheckAutomatResponse => {
    if (response.data) {
      return {
        total: response.data.total,
        rows: response.data.Row,
      };
    }
    return {} as CheckAutomatResponse;
  },
};
export default AutomatCheckDTO;
